import React from 'react'

export interface SectionFooterProps {
    title?: React.ReactNode
    subtitle?: React.ReactNode
}

export const SectionFooter: React.FC<SectionFooterProps> = ({
    title,
    subtitle,
}) => (
    <footer
        className="flex w-full flex-col justify-start bg-oxfordBlue px-6 py-12"
        data-testid="section-footer"
    >
        <div className="mx-auto w-full max-w-[1024px] xl:px-6">
            {title && (
                <div className="text-heading-5 mb-2 font-bold text-white">
                    {title}
                </div>
            )}
            {subtitle && (
                <div className="text-body-medium text-white">{subtitle}</div>
            )}
        </div>
    </footer>
)
